import React from "react";
import Starter from "./Starter";
import About from "./About";
import Why from "./Why";
import Starter2 from "./Starter2";
import Blogs from "./Blogs";
import Footer from "./Footer";



function Home() {


  return (
    <div>
        <Starter/>
        <About />
        <Why />
        <Starter2 />
        <Blogs />
        <Footer />
    </div>
  );
}

export default Home;
